import { render, staticRenderFns } from "./Product_abc.vue?vue&type=template&id=be212d94&scoped=true"
import script from "./Product_abc.vue?vue&type=script&lang=js"
export * from "./Product_abc.vue?vue&type=script&lang=js"
import style0 from "./Product_abc.vue?vue&type=style&index=0&id=be212d94&prod&lang=css"
import style1 from "./Product_abc.vue?vue&type=style&index=1&id=be212d94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be212d94",
  null
  
)

export default component.exports